import React, { useEffect, useState } from 'react';
import { Container, Typography, CircularProgress, Box } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react'; // ✅ fixed import
import { toast } from 'react-toastify';
import config from '../config'; // assuming backendUrl is defined here

const QR = () => {
  const [userLink, setUserLink] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserLink = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error('Not logged in.');
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`${config.backendUrl}/api/link`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();

        if (res.ok) {
          setUserLink(data.link);
        } else {
          toast.error(data.message || 'Failed to fetch link.');
        }
      } catch (err) {
        toast.error('Error fetching link.');
      } finally {
        setLoading(false);
      }
    };

    fetchUserLink();
  }, []);

  return (
    <Container sx={{ textAlign: 'center', mt: 5 }}>
      <Typography variant="h4" gutterBottom>User QR Code</Typography>
      {loading ? (
        <CircularProgress />
      ) : userLink ? (
        <>
          <Typography variant="body1" gutterBottom>{userLink}</Typography>
          <Box mt={3}>
            <QRCodeCanvas value={userLink} size={256} />
          </Box>
        </>
      ) : (
        <Typography color="error">No link found for this user.</Typography>
      )}
    </Container>
  );
};

export default QR;
